import { makeStyles } from 'tss-react/mui';

export const useOfflineModalContentStyles = makeStyles()((theme) => ({
  customButtonBackground: {
    backgroundColor: '#FAFAFA',
    '&:hover': {
      backgroundColor: '#F0F0F0',
    },
  },
  wrapper: {
    gap: '24px',
    [theme.breakpoints.down('sm')]: {
      gap: '16px',
    },
  },
}));
